export class AppConstants {
  static readonly ROLES = {
    ADMIN: 'ROLE_ADMIN',
    HEAD: 'ROLE_HEAD',
    USER: 'ROLE_USER',
    STOREKEEPER: 'ROLE_STOREKEEPER'
  };

  static readonly HTTP_STATUS = {
    OK: 200,
    NO_CONTENT: 204,
    PRECONDITION_FAILED: 412,
    UNPROCESSIBLE: 422
  };

  static readonly MODAL_RESULT = {
    OK: 'ok',
    CANCEL: 'cancel'
  };

  static readonly CLOTHES_STATUS = {
    IN_WORK: 'The task has been accepted',
    IN_PROCESSING: 'Task in progress',
    COMPLETE: 'The task is completed'
  };
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/app.constants.ts